/**
 * Created by Timur on 21.08.2026
 */

Mission.TYPE_MERGE2_MISSION = 105;

Mission.REGISTRATIONS.set(Mission.TYPE_MERGE2_MISSION, () => ({
    available: cleverapps.config.availables.MERGE2_MISSION_MISSION,
    name: "Merge2Mission",
    logic: Merge2MissionLogic,
    view: Merge2MissionWindow,
    startWindow: Merge2MissionStartWindow,
    semaphore: Mission.SEMAPHORE_ALWAYS,
    canStart: () => cleverapps.abExperiments.getGroup(ABExperiments.Tests.merge2missionLadacha) !== "B" && Merge2MissionHelper.hasBundles(Merge2MissionHelper.getPeriod()),
    feature: "merge2mission",
    duration: "1 week",
    oncePerEvent: true,
    sideBarJson: false,
    rowView: cleverapps.config.type === "merge2" ? Merge2MissionRowView : undefined
}));

cleverapps.InitByFeature["merge2mission"] = function () {
    cleverapps.tutorial.register(Merge2MissionTutorial());
};
